
import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NavBarComponent, RouterOutlet, FooterComponent]
})
export class AppComponent {
  title = 'Auth0 Angular SDK Sample';
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly location = inject(Location);

  isPdfPopoutRoute = this.isPdfPopupUrl(this.location.path() || this.router.url);

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(event => {
        this.isPdfPopoutRoute = this.isPdfPopupUrl(event.urlAfterRedirects);
      });
  }

  private isPdfPopupUrl(url: string): boolean {
    return url.includes('/fmeda-pdf');
  }
}
